import React from 'react'

import { CategoryCard, ThemeProps } from '@hhgtech/hhg-components'
import {
  StyledCategoriesContainer,
  StyledCategoryWrapper,
} from 'components/pages/categories/index.styled'
import { Category as ICategory } from 'interfaces/types'
import styled from 'styled-components'

const BannerContainer = styled.section`
  display: flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  background: ${(props: ThemeProps & { 'data-bg': string }) =>
    props['data-bg'] || props.theme.mbColors.lightBlue};
  border-radius: 40px;
`
const AsideCategories = ({ categories }: { categories: ICategory[] }) => {
  return (
    <StyledCategoriesContainer
      className="aside-categories"
      data-layout-type="long"
    >
      {categories.map((category: ICategory) => (
        <StyledCategoryWrapper
          className="aside-category"
          data-layout-type="long"
          key={String(category.termId)}
        >
          <CategoryCard
            category={category}
            href={category.permalink}
            imgBanner={
              <BannerContainer data-bg={category.imageColor}>
                <img
                  loading="lazy"
                  width={24}
                  height={24}
                  src={category.iconUrl || '/images/bookDoctor.svg'}
                  alt={category.displayName}
                />
                {/* <Image
                  width={24}
                  height={24}
                  src={category.iconUrl || '/images/bookDoctor.svg'}
                  objectFit="contain"
                  objectPosition="contain"
                  alt={category.displayName}
                /> */}
              </BannerContainer>
            }
            label={category.displayName}
          />
        </StyledCategoryWrapper>
      ))}
    </StyledCategoriesContainer>
  )
}

export default AsideCategories
